@if (showRequirements()) {
  <onyx-message intent="information">
    <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

    {{
      `${I18N}.${hasRequiredDocuments() ? 'documentsRequired' : 'documentsNotRequired'}`
        | translate
    }}

    @if (hasRequiredDocuments()) {
      <p description>
        {{ `${I18N}.minOneDocumentRequired` | translate }}
      </p>
    }
  </onyx-message>
}

<app-documents-form-list
  [documents]="documents()"
  [orderDocuments]="order().documents"
  [uuid]="order().uuid"
  placeholder="orders.orderModal.noDocuments"
  [close$]="close$()"
></app-documents-form-list>

<onyx-button
  variant="outlined"
  [size]="32"
  leftIcon="add-outlined"
  [disabled]="editLock().disabled"
  [onyxTooltip]="editLock().tooltip"
  [onyxTooltipDisabled]="!editLock().disabled"
  (click)="addDocument()"
>
  {{ 'labels.add' | translate }}
</onyx-button>
